import { ListChecksIcon, ClipboardListIcon, LayersIcon, FileTextIcon } from 'lucide-react';

export const stats = [
  { icon: ListChecksIcon, value: '240', label: 'Fichas visuales' },
  { icon: ClipboardListIcon, value: '51', label: 'Clases estructuradas' },
  { icon: LayersIcon, value: '6+6', label: 'Tomos y bonos' },
  { icon: FileTextIcon, value: '515', label: 'Páginas en PDF' }
];
